import * as Yup from 'yup';

export default Yup.object().shape({
  nip: Yup.string()
    .length(4, 'SCHEMA_ERRORS.NIP_LENGTH')
    .required('SCHEMA_ERRORS.NIP_REQUIRED')
});
